import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface UpdateCustomerRequest {
    customer_memo: string;
}

export const usePutCustomerMemo = (
    successCallback?: () => void,
): UseMutationResult<null, Error, { customerId: number; memoId: number; customerMemoData: UpdateCustomerRequest }> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, { customerId: number; memoId: number; customerMemoData: UpdateCustomerRequest }>({
        mutationFn: async ({ customerId, memoId, customerMemoData }) => {
            const response = await axios.put(
                enum_api_uri.put_customer_memo
                    .replace(":customer_idx", customerId?.toString() || "")
                    .replace(":customer_memo_idx", memoId?.toString() || ""),
                customerMemoData,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ["getCustomerMemo"] });
            successCallback?.();
        },
    });
};
